@if (form$ | async) {
  @if ((form$ | async)?.loading || (loading$ | async)) {
    <crm-spinner></crm-spinner>
  }

  @if ((loading$ | async) === false) {
    <div class="grid">
      <div class="col-12">
        <p-card>
          <div class="p-fluid">
            <div class="field">
              <label class="font-medium required-field">
                {{ metadata?.name?.label }}
              </label>
              <crm-input-text
                [(value)]="status.name"
                placeholder="Введите название статуса"
                [isError]="$any(errors?.name)"
                [disabled]="!editable || deleted"
                class="w-full">
              </crm-input-text>
              @if (errors?.name) {
                <small class="p-error">
                  {{ errors.name | join }}
                </small>
              }
            </div>

            <div class="field">
              <label
                class="font-medium required-field"
                [pTooltip]="metadata?.transitions?.hint"
                tooltipPosition="bottom">
                {{ metadata?.transitions?.label }}
              </label>
              <crm-deal-status-multi-select
                [isFloatLabel]="false"
                [(selectedStatuses)]="status.transitions"
                [withoutIds]="withoutIds$ | async"
                [disabled]="deleted"
                label="Переход в статусы"
                appendTo="body">
              </crm-deal-status-multi-select>
              @if (errors?.transitions) {
                <small class="p-error">
                  {{ errors.transitions | join }}
                </small>
              }
            </div>

            <div class="field-checkbox">
              <p-checkbox
                inputId="initial"
                [(ngModel)]="status.initial"
                [binary]="true"
                [disabled]="deleted"></p-checkbox>
              <label
                [for]="'initial'"
                [pTooltip]="metadata?.initial?.hint"
                tooltipPosition="bottom">
                  {{ metadata?.initial?.label }}
                </label>
            </div>

            <div class="field-checkbox">
              <p-checkbox
                inputId="active"
                [(ngModel)]="status.active"
                [disabled]="!editable || deleted"
                [binary]="true"></p-checkbox>
              <label
                [for]="'active'"
                [pTooltip]="metadata?.active?.hint"
                tooltipPosition="bottom">
                {{ metadata?.active?.label }}
              </label>
            </div>

            <div class="field-checkbox">
              <p-checkbox
                inputId="isCommentRequired"
                [(ngModel)]="status.isCommentRequired"
                [disabled]="!editable || deleted"
                [binary]="true"></p-checkbox>
              <label
                [for]="'isCommentRequired'"
                [pTooltip]="metadata?.isCommentRequired?.hint"
                tooltipPosition="bottom">
                {{ metadata?.isCommentRequired?.label }}
              </label>
            </div>

            <div class="field">
              <label
                class="font-medium"
                [pTooltip]="metadata?.color?.hint"
                tooltipPosition="bottom">
                {{ metadata?.color?.label }}
              </label>
              <div>
                <crm-color-picker [disabled]="!editable || deleted" [(color)]="status.color"></crm-color-picker>
              </div>
              <div class="p-inputgroup crm-hex-inputgroup mt-2">
                <span class="p-inputgroup-addon">Hex</span>
                <crm-input-text
                  [(value)]="status.color"
                  [disabled]="!editable || deleted"
                  [isError]="$any(errors?.color)"></crm-input-text>
              </div>
              @if (errors?.color) {
                <small class="p-error">
                  {{ errors.color | join }}
                </small>
              }
            </div>

            <p-divider></p-divider>

            <div class="field">
              <label class="font-medium">Предпросмотр</label>
              <div>
                <crm-status-label
                  [name]="status.name || 'Статус'"
                  [color]="status.color"></crm-status-label>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>

    @if ((form$ | async)?.canWrite) {
      <div class="mt-3">
        <div class="flex flex-wrap justify-content-between">
          @if (!status?.id || (status.id && !deleted)) {
            <crm-button
              label="Сохранить"
              styleClass="p-button-success"
              (onClick)="saveStatus()">
            </crm-button>
          }

          @if ((form$ | async)?.isShowDelete && status.id) {
            @if (!deleted && editable) {
              <crm-button
                label="Удалить"
                styleClass="p-button-danger p-button-text"
                (onClick)="deleteStatus()">
              </crm-button>
            } @else if (deleted) {
              <crm-button
                label="Восстановить"
                styleClass="p-button-text"
                (onClick)="restoreStatus()">
              </crm-button>
            }
          }
        </div>
      </div>
    }
  }
}
